export const generatedApiTags = [
	'BillingRates',
	'Broker',
	'Dispatch',
	'CanceledDispatch',
	'CloudStorage',
	'Contact',
	'Customer',
	'Order',
	'Driver',
	'Document',
	'Equipment',
	'DumpLineItem',
	'DumpRate',
	'EquipmentType',
	'FreightBillingLineItem',
	'HourlyLineItem',
	'IncomeCode',
	'Invoice',
	'Job',
	'Quote',
	'JobNote',
	'LineItem',
	'MaterialLineItem',
	'MiscLineItem',
	'SiteHaulingLineItem',
	'Material',
	'MaterialPrice',
	'MiscSettings',
	'OrderReview',
	'OrderLineItem',
	'PriceList',
	'QuickBooks',
	'QuickBooksProduct',
	'QuoteAttachment',
	'Region',
	'Site',
	'SurchargeCode',
	'TermsCode',
	'Trash',
	'TaxCode',
	'User'
]